/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { artistService } from '../../../services/artist.service'
import { CardEvent } from '../../../components/Events/CardEvent'
import { useGeneralApp } from '../../../hooks/useGeneralApp'
import './style.scss'

import Image from '../../../assets/FOBbundlesSMFSdfad-4.webp'

const merchandising = [
  {
    title: 'SO MUCH (FOR) STARDUST VINYL BLACK',
    price: 27.98,
    imgUrl: Image
  },
  {
    title: 'SO MUCH (FOR) STARDUST VINYL BLUE',
    price: 27.98,
    imgUrl: Image
  },
  {
    title: 'SO MUCH (FOR) STARDUST VINYL GREEN',
    price: 27.98,
    imgUrl: Image
  }
]

export const ArtistDetail = () => {
  const { idArtist } = useParams()
  const [artist, setArtist] = useState({})
  const { isLoading } = useGeneralApp()
  const navigate = useNavigate()

  useEffect(() => {
    const getArtist = async () => {
      try {
        const dbArtist = await artistService.getOneArtist(idArtist)
        setArtist(dbArtist)
        console.log(dbArtist)
      } catch (error) {
        console.log(error.response.status)
        setArtist(null)
      }
    }
    getArtist()
  }, [])

  if (artist === null) return navigate('recurso-no-encontrado')

  if (!isLoading && artist) {
    return (
      <section className="container mt-2 mt-lg-4 mt-xl-5">
        {/* Content */}
        <ArtistDescription artist={artist}/>
        <ArtistSocialLinks artist={artist}/>
        <MerchItems
          merchandising={ merchandising }
          artist={artist}
        />
      </section>
    )
  }
}

const ArtistDescription = ({ artist }) => {
  return (
    <div className='artist-header row' id='parent'>
      <div className="card_descripcion text-front">
        <h4 className="h1 pb-md-2 pb-lg-3">
          Artista
        </h4>
        <h2 className='increment-font'>
          {artist.nombre_artista}
        </h2>
        <div>
          <h4 className="h4 pb-md-2 pb-lg-3 reduce-font">
            Canción más popular
          </h4>
        </div>
      </div>
      <div>
        <img className='img-resize' src = {artist.foto_artista}></img>
      </div>
    </div>
  )
}

const ArtistSocialLinks = ({ artist }) => {
  return (
    <div className="card_descripcion">
      <h4 className="h4 pb-md-2 pb-lg-3 ">Enlace a RRSS</h4>
        <ul className="list-unstyled mb-5">
          { /* Aquí se checa si el artista tiene spotify */ }
            { artist.spotify !== '#'
              ? <li className="d-flex align-items-center mb-2">
                <a href= {artist.spotify} rel="noreferrer" target='_blank' className='linkini'> Spotify</a>
              </li>
              : null
            }
          { /* Aquí se checa si el artista tiene youtube */ }
            { artist.youtube !== '#'
              ? <li className=" align-items-center mb-2">
                <a href= {artist.youtube} rel="noreferrer" target='_blank' className='linkini'> Youtube</a>
              </li>
              : null
            }
          { /* Aquí se checa si el artista tiene instagram */ }
          { artist.instagram !== '#'
            ? <li className="d-flex align-items-center mb-2">
            <a href= {artist.instagram} rel="noreferrer" target='_blank' className='linkini'>Instagram</a>
            </li>
            : null
          }
        </ul>
    </div>
  )
}

const ArtistNextEvents = ({ artist }) => {
  return (
    <>
      <h3 className="pb-4 mb-2 mb-md-0">
        Próximos eventos
      </h3>
      <div className="row d-flex flex-row flex-nowrap overflow-auto">
        {artist.nextEvents !== undefined
          ? artist.nextEvents.slice(0, 12).map((nextevent, index) => (
      <div className="col-12 col-md-3"
        key={index}
      >
        <CardEvent
          // setIsRejected={setIsRejected}
          // isRejected={isRejected}
          // isAdmin={isAdmin}
          {...nextevent}
        />
      </div>
          ))
          : ''
    }
    </div>
    </>
  )
}

const MerchItems = ({ merchandising, artist }) => {
  const navigate = useNavigate()

  return (
    <div className='card_descripcion'>
      <h4 className="h4 pb-md-2 pb-lg-3 ">Merchandising</h4>
      <div className='merchandising-grid'>
      {
        merchandising.map(merch => (
          /* En lugar de usar el titulo se debe usar el id del merch */
          <div
            key={merch.title}
            className='merchandising-grid-item'
            onClick={() => navigate(`/artista/${artist.aid}/merch/${merch.title}`)}
          >
            <img
              src={merch.imgUrl}
            />
            <h5 className='h5 pb-md-2 pb-lg-3'>{merch.title}</h5>
            <h6>${merch.price} USD</h6>
          </div>
        ))
      }
      </div>
    </div>
  )
}
